<template>
  <el-dialog title="收费标准" :visible.sync="dialogTableVisible" width="1200px">
    <el-descriptions title="基本信息" :column="2">
      <el-descriptions-item label="名称">{{ detail.name }}</el-descriptions-item>
      <el-descriptions-item label="收费类型">{{ typeMap[detail.type] }}</el-descriptions-item>
      <el-descriptions-item label="免费时长">{{ detail.freeDuration }}</el-descriptions-item>
      <el-descriptions-item label="收费上限（元）">{{ detail.chargeUpperLimit }}</el-descriptions-item>
      <el-descriptions-item label="计时费用">{{ detail.chargePrice }}</el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      detail: {},
      typeMap: {
        4: '计时'
      },
    }
  },
  methods: {
    open(row) {
      this.detail = row
      this.dialogTableVisible = true
    },
  }
}
</script>

<style lang="scss" scoped></style>
